import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref, nextTick } from "../../../../adapter-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-face',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
  isPC: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props


const data = ref();
const skeleton: any = ref();
watchEffect(() => {
  data.value = props.content;
  if (!data.value) return;
  nextTick(() => {
    // todo 大小显示
  });
});

return { __sfc: true,props, data, skeleton }
}

})